import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocTeamCustomerLogsRoute: InvariantJiraRoute = {
	name: 'eoc-team-customer-logs',
	path: '/jira/settings/products/ops/jira-service-management-audit-logs',
	exact: true,
};
